import { rrTokens } from './rr-tokens.ts'

export const rrFlowStyles = `
${rrTokens('.rrf')}

.rrf, .rrf * { margin: 0; padding: 0; box-sizing: border-box; }
.rrf {
  min-height: 100vh;
  background: var(--ink);
  color: var(--text);
  font-family: var(--sans);
  -webkit-font-smoothing: antialiased;
}
// The one literal here: body is outside the .rrf scope, so --ink never resolves.
body:has(.rrf) { background: var(--ink, #08080A); }
.rrf :is(a, button, input, textarea):focus-visible {
  outline: 2px solid var(--brand-hi);
  outline-offset: 3px;
}
.rrf-wrap { max-width: 1140px; margin: 0 auto; padding: 0 clamp(20px, 4vw, 48px); }
.rrf-narrow { max-width: 720px; margin: 0 auto; padding: 0 clamp(20px, 5vw, 32px); }

.rrf-top {
  display: flex; align-items: center; justify-content: space-between;
  padding: 24px clamp(20px, 4vw, 48px);
  border-bottom: 1px solid var(--line-soft);
}
.rrf-mark {
  font-family: var(--display); font-weight: 800; font-size: 17px;
  letter-spacing: -0.01em; color: var(--text); text-decoration: none;
}
.rrf-steps { display: flex; gap: 7px; align-items: center; flex-shrink: 0; }
.rrf-bands > .rrf-steps { margin-bottom: 20px; }
.rrf-tick { width: 30px; height: 3px; border-radius: 2px; background: var(--line); }
.rrf-tick[data-on='true'] { background: var(--brand); }
.rrf-tick[data-now='true'] { background: var(--brand-hi); }
.rrf-stepnum {
  font-family: var(--mono); font-size: 12px; letter-spacing: 0.08em;
  color: var(--text-3); text-transform: uppercase;
}

.rrf-eyebrow {
  font-family: var(--mono); font-size: 12.5px; letter-spacing: 0.14em;
  text-transform: uppercase; color: var(--brand-soft);
  display: flex; align-items: center; gap: 10px;
}
.rrf-h1 {
  font-family: var(--display); font-weight: 800;
  font-size: clamp(36px, 5.4vw, 58px); line-height: 1.06; letter-spacing: -0.025em;
  margin-top: 22px;
}
.rrf-lede {
  font-size: clamp(18px, 2.2vw, 21px); line-height: 1.55; color: var(--text-2);
  margin-top: 18px; max-width: 46ch;
}
.rrf-help { font-size: 16px; line-height: 1.55; color: var(--text-3); margin-top: 10px; }
.rrf-fine {
  font-family: var(--mono); font-size: 12px; letter-spacing: 0.1em;
  text-transform: uppercase; color: var(--text-3);
}
.rrf-err { color: var(--bad); font-size: 15px; margin-top: 10px; }
.rrf-ok { color: var(--good); }

.rrf-note-inline {
  margin: 0 0 18px;
  padding: 12px 14px;
  border: 1px solid var(--line-soft);
  border-radius: 10px;
  font-size: 14px; line-height: 1.55;
  color: var(--text-2);
}
.rrf-note-inline a { color: var(--brand-soft); }

.rrf-split {
  display: grid; gap: clamp(32px, 6vw, 72px); align-items: center;
  min-height: calc(100vh - 73px);
  padding: clamp(44px, 7vw, 72px) 0;
}
@media (min-width: 900px) { .rrf-split { grid-template-columns: 1fr 1fr; } }

.rrf-agenda { margin-top: 40px; display: flex; flex-direction: column; }
.rrf-agenda-row {
  display: grid; grid-template-columns: 34px 1fr auto; gap: 18px;
  align-items: baseline; padding: 20px 0; border-top: 1px solid var(--line-soft);
}
.rrf-agenda-row:last-child { border-bottom: 1px solid var(--line-soft); }
.rrf-agenda-n { font-family: var(--mono); font-size: 13px; color: var(--brand-soft); }
.rrf-agenda-t { font-size: 18px; color: var(--text); }
.rrf-agenda-t span { color: var(--text-3); }
.rrf-agenda-min { font-family: var(--mono); font-size: 12px; color: var(--text-3); }

.rrf-paper {
  background: var(--paper); color: var(--paper-ink);
  border-radius: 16px; padding: clamp(32px, 4.4vw, 48px);
  box-shadow: 0 30px 70px -30px rgba(0,0,0,0.7);
}
.rrf-drop {
  border: 1.5px dashed var(--paper-line); border-radius: 12px;
  padding: clamp(36px, 5.4vw, 56px) 24px; text-align: center;
  transition: border-color 160ms var(--spring), background 160ms var(--spring);
}
.rrf-drop[data-over='true'] { border-color: var(--brand-paper); background: var(--brand-paper-dim); }
.rrf-drop-icon { color: var(--brand-paper); }
.rrf-drop-title {
  font-family: var(--display); font-weight: 700; font-size: 23px;
  margin-top: 18px; letter-spacing: -0.01em;
}
.rrf-drop-sub { font-size: 16px; color: var(--paper-body); margin-top: 8px; }
.rrf-drop-name {
  font-family: var(--mono); font-size: 15px; color: var(--paper-ink);
  margin-top: 14px; word-break: break-all;
}
.rrf-paper-cap {
  font-family: var(--mono); font-size: 11.5px; letter-spacing: 0.12em;
  text-transform: uppercase; color: var(--text-3);
  margin-top: 18px; text-align: center;
}
.rrf-paper-cap--prose {
  font-family: var(--sans); font-size: 13px; letter-spacing: 0;
  text-transform: none; line-height: 1.55; color: var(--text-2);
  max-width: 46ch; margin-left: auto; margin-right: auto;
}
.rrf-paper-cap--prose a { color: var(--brand-soft); }
.rrf-pbtn {
  margin-top: 24px; display: inline-flex; align-items: center; gap: 8px;
  background: var(--brand-paper); color: #fff; border: 0; cursor: pointer;
  padding: 15px 26px; border-radius: 10px;
  font-family: var(--sans); font-weight: 700; font-size: 17px;
  transition: transform 160ms var(--spring), background 160ms var(--spring);
}
.rrf-pbtn:hover { background: var(--brand-paper-hi); transform: translateY(-1px); }
.rrf-pbtn:disabled { opacity: 0.55; cursor: default; transform: none; }
.rrf-plink {
  margin-top: 16px; background: none; border: 0; cursor: pointer;
  font-family: var(--sans); font-size: 16px; color: var(--paper-body);
  text-decoration: underline; text-underline-offset: 3px;
}
.rrf-spin {
  width: 30px; height: 30px; border-radius: 50%; margin: 0 auto;
  border: 2.5px solid var(--paper-line); border-top-color: var(--brand-paper);
  animation: rrf-spin 720ms linear infinite;
}
@keyframes rrf-spin { to { transform: rotate(360deg); } }
@media (prefers-reduced-motion: reduce) {
  .rrf-spin { animation-duration: 2.4s; }
  .rrf *, .rrf *::before { transition-duration: 1ms !important; }
}
.rrf-check { color: var(--brand-paper); }

.rrf-bands { padding: clamp(38px, 5.5vw, 68px) 0 150px; }
.rrf-band { padding: clamp(30px, 4.4vw, 46px) 0; border-top: 1px solid var(--line-soft); }
.rrf-band:first-of-type { border-top: 0; }
.rrf-band-n {
  font-family: var(--mono); font-size: 13px; letter-spacing: 0.1em;
  color: var(--brand-soft);
}
.rrf-band-q {
  font-family: var(--display); font-weight: 700;
  font-size: clamp(23px, 2.8vw, 29px); line-height: 1.25;
  letter-spacing: -0.015em; margin-top: 10px;
}
.rrf-band-body { margin-top: 22px; }

.rrf-grid2 { display: grid; gap: 18px; }
@media (min-width: 560px) { .rrf-grid2 { grid-template-columns: 1fr 1fr; } }
.rrf-label {
  display: block; font-family: var(--mono); font-size: 11.5px;
  letter-spacing: 0.12em; text-transform: uppercase; color: var(--text-3);
  margin-bottom: 9px;
}
.rrf-input, .rrf-textarea {
  width: 100%; background: var(--ink-2); color: var(--text);
  border: 1px solid var(--line); border-radius: 10px;
  padding: 15px 17px; font-family: var(--sans); font-size: 17px;
  transition: border-color 140ms var(--spring);
}
.rrf-input:focus, .rrf-textarea:focus { border-color: var(--brand); outline: none; }
.rrf-input::placeholder, .rrf-textarea::placeholder { color: var(--text-3); }
.rrf-textarea { min-height: 200px; resize: vertical; line-height: 1.6; }
.rrf-money { font-family: var(--mono); font-size: 24px; letter-spacing: 0.01em; }

.rrf-check-row {
  display: flex; align-items: flex-start; gap: 12px; cursor: pointer;
  font-size: 17px; color: var(--text); line-height: 1.5;
}
.rrf-check-row input { margin-top: 3px; width: 19px; height: 19px; accent-color: var(--brand); flex-shrink: 0; }

.rrf-chips { display: flex; flex-wrap: wrap; gap: 9px; margin-bottom: 13px; }
.rrf-chip {
  display: inline-flex; align-items: center; gap: 8px;
  background: var(--brand-dim); border: 1px solid rgba(107,69,255,0.35);
  color: var(--text); border-radius: 999px; padding: 8px 9px 8px 16px; font-size: 15.5px;
}
.rrf-chip button {
  background: none; border: 0; color: var(--brand-soft); cursor: pointer;
  font-size: 17px; line-height: 1; padding: 0 4px;
}
.rrf-chip button:hover { color: var(--text); }

.rrf-stepper { display: flex; align-items: center; gap: 18px; }
.rrf-stepper button {
  width: 48px; height: 48px; border-radius: 10px; cursor: pointer;
  background: var(--ink-2); border: 1px solid var(--line);
  color: var(--text); font-size: 22px; line-height: 1;
  transition: border-color 140ms var(--spring);
}
.rrf-stepper button:hover:not(:disabled) { border-color: var(--brand); }
.rrf-stepper button:disabled { opacity: 0.35; cursor: default; }
.rrf-stepper-val { font-family: var(--mono); font-size: 32px; min-width: 2ch; text-align: center; }

.rrf-choices { display: flex; flex-wrap: wrap; gap: 11px; }
.rrf-choice {
  cursor: pointer; border: 1px solid var(--line); border-radius: 10px;
  padding: 15px 22px; font-size: 17px; background: var(--ink-2); color: var(--text-2);
  transition: border-color 140ms var(--spring), color 140ms var(--spring);
}
.rrf-choice:has(input:checked) { border-color: var(--brand); color: var(--text); background: var(--brand-dim); }
.rrf-choice input { position: absolute; opacity: 0; pointer-events: none; }

.rrf-foot {
  position: sticky; bottom: 0;
  background: linear-gradient(to top, var(--ink) 78%, rgba(11,12,16,0));
  padding: 44px 0 28px; margin-top: 8px;
}
.rrf-foot-row {
  display: flex; align-items: center; justify-content: space-between;
  gap: 16px; flex-wrap: wrap;
}
.rrf-foot .rrf-fine { display: block; margin-top: 14px; }
.rrf-btn {
  display: inline-flex; align-items: center; gap: 9px;
  background: var(--brand); color: #fff; border: 0; cursor: pointer;
  padding: 17px 30px; border-radius: 11px;
  font-family: var(--sans); font-weight: 700; font-size: 17.5px;
  text-decoration: none;
  transition: background 160ms var(--spring), transform 160ms var(--spring);
}
.rrf-btn:hover:not(:disabled) { background: var(--brand-hi); transform: translateY(-1px); }
.rrf-btn:disabled {
  background: var(--ink-2); color: var(--text-3);
  box-shadow: inset 0 0 0 1px var(--line);
  cursor: not-allowed; transform: none;
}

.rrf-nav {
  display: flex; align-items: center; justify-content: space-between;
  gap: 16px; flex-wrap: wrap;
}
.rrf-nav-fwd { display: flex; align-items: center; gap: 20px; }
.rrf-nav-back {
  font-size: 15.5px; color: var(--text-3); text-decoration: none;
  padding: 8px 0;
}
.rrf-nav-back:hover { color: var(--text-2); }
.rrf-ghost {
  background: none; border: 0; cursor: pointer; padding: 8px 0;
  font-family: var(--sans); font-size: 15.5px; color: var(--text-3);
  text-decoration: underline; text-underline-offset: 4px;
}
.rrf-ghost:hover { color: var(--text-2); }

.rrf-value {
  border: 1px solid var(--line); border-radius: 14px;
  padding: clamp(26px, 4vw, 36px); background: var(--ink-2); margin-top: 34px;
}
.rrf-value-head {
  font-family: var(--display); font-weight: 800; font-size: 26px;
  letter-spacing: -0.015em;
}
.rrf-value-body { font-size: 17px; line-height: 1.6; color: var(--text-2); margin-top: 14px; }
.rrf-consent {
  margin-top: 28px; border: 1px solid var(--line); border-radius: 14px;
  padding: 24px; background: var(--ink-3);
}
.rrf-consent-text { font-size: 16px; line-height: 1.6; color: var(--text); }
.rrf-under {
  margin-top: 20px; display: flex; flex-direction: column; gap: 8px; align-items: center;
  text-align: center;
}

.rrf-timeline { display: flex; flex-direction: column; }
.rrf-tl {
  display: grid; grid-template-columns: 140px 1fr; gap: 22px;
  padding: 22px 0; border-top: 1px solid var(--line-soft);
}
@media (max-width: 640px) { .rrf-tl { grid-template-columns: 1fr; gap: 5px; } }
.rrf-tl-when { font-family: var(--mono); font-size: 12px; color: var(--text-3); padding-top: 4px; }
.rrf-tl-title { font-size: 17px; font-weight: 600; }
.rrf-tl-body { font-size: 16px; color: var(--text-2); margin-top: 6px; line-height: 1.6; }

.rrf-app {
  border: 1px solid var(--line); border-radius: 14px;
  padding: 26px; margin-bottom: 16px; background: var(--ink-2);
}
.rrf-app[data-open='true'] { border-color: rgba(107,69,255,0.4); }
.rrf-app-top { display: flex; justify-content: space-between; gap: 14px; flex-wrap: wrap; }
.rrf-app-co { font-family: var(--display); font-weight: 700; font-size: 20px; }
.rrf-app-role { font-size: 17px; color: var(--text-2); margin-top: 3px; }
.rrf-app-clock { font-family: var(--mono); font-size: 13px; color: var(--brand-soft); }
.rrf-app-why { font-size: 16px; line-height: 1.6; color: var(--text-2); margin-top: 16px; }
.rrf-app-flags {
  font-size: 15px; line-height: 1.55; color: var(--warn);
  margin-top: 14px; white-space: pre-line;
}
.rrf-receipt {
  font-family: var(--mono); font-size: 13px; color: var(--text-3);
  margin-top: 16px; display: grid; gap: 5px;
}
.rrf-app-acts { display: flex; gap: 11px; margin-top: 20px; flex-wrap: wrap; }
.rrf-act {
  border: 1px solid var(--line); background: none; color: var(--text-2);
  border-radius: 9px; padding: 12px 18px; font-size: 15.5px; cursor: pointer;
  font-family: var(--sans);
  transition: border-color 140ms var(--spring), color 140ms var(--spring);
}
.rrf-act:hover { border-color: var(--brand); color: var(--text); }
.rrf-act--go { background: var(--brand); border-color: var(--brand); color: #fff; }
.rrf-act--go:hover { background: var(--brand-hi); color: #fff; }

.rrf-top-right { display: flex; align-items: center; gap: clamp(12px, 3vw, 26px); }

.rrf-acct { position: relative; }
.rrf-acct-btn {
  display: flex; align-items: center; gap: 8px;
  padding: 6px 12px; border-radius: 100px;
  border: 1px solid var(--line-soft);
  font-size: 14px; color: var(--text-2);
  cursor: pointer; list-style: none;
}
.rrf-acct-btn::-webkit-details-marker { display: none; }
.rrf-acct-btn:hover { color: var(--text); border-color: var(--line); }
.rrf-acct-caret {
  width: 0; height: 0;
  border-left: 4px solid transparent; border-right: 4px solid transparent;
  border-top: 5px solid currentColor;
  opacity: 0.7;
}
.rrf-acct[open] .rrf-acct-caret { transform: rotate(180deg); }
.rrf-acct-menu {
  position: absolute; right: 0; top: calc(100% + 8px);
  z-index: 40; min-width: 208px;
  display: flex; flex-direction: column;
  padding: 6px;
  background: var(--ink-2); border: 1px solid var(--line);
  border-radius: 12px;
  box-shadow: 0 18px 44px rgba(0,0,0,0.5);
}
.rrf-acct-item {
  display: block; width: 100%;
  padding: 9px 12px; border-radius: 8px;
  font-size: 14px; text-align: left;
  color: var(--text-2); text-decoration: none;
  background: none; border: 0; cursor: pointer;
}
.rrf-acct-item:hover { background: rgba(255,255,255,0.05); color: var(--text); }
.rrf-acct-item--out { color: var(--bad); }
.rrf-acct-in { font-size: 14px; color: var(--text-2); text-decoration: none; }
.rrf-acct-in:hover { color: var(--text); }
@media (max-width: 560px) {
  .rrf-acct-name { max-width: 72px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
  .rrf-acct-btn { padding: 6px 10px; font-size: 13px; }
  .rrf-stepnum { display: none; }
  .rrf-tick { width: 18px; }
}

.rrf-tabs {
  display: flex; gap: 26px;
  overflow-x: auto;
  scrollbar-width: none;
  -webkit-overflow-scrolling: touch;
  border-bottom: 1px solid var(--line-soft); padding: 0 0 2px;
}
.rrf-tabs::-webkit-scrollbar { display: none; }
.rrf-tab { flex: 0 0 auto; }
@media (max-width: 420px) { .rrf-tabs { gap: 18px; } }
.rrf-tab {
  font-size: 16px; color: var(--text-3); text-decoration: none;
  padding: 14px 0; border-bottom: 2px solid transparent; margin-bottom: -2px;
}
.rrf-tab[data-on='true'] { color: var(--text); border-bottom-color: var(--brand); }
.rrf-tab:hover { color: var(--text-2); }

.rrf-stats { display: flex; flex-wrap: wrap; gap: clamp(26px, 5vw, 58px); margin: 30px 0 6px; }
.rrf-stat-n { font-family: var(--mono); font-size: 38px; letter-spacing: -0.02em; }
.rrf-stat-l {
  font-family: var(--mono); font-size: 11.5px; letter-spacing: 0.12em;
  text-transform: uppercase; color: var(--text-3); margin-top: 5px;
}

.rrf-degraded {
  border: 1px solid var(--line); border-left: 2px solid var(--brand);
  border-radius: 0 12px 12px 0; padding: 20px 24px; background: var(--ink-2);
  margin: 26px 0;
}
.rrf-degraded-t { font-weight: 700; font-size: 17px; }
.rrf-degraded-b { font-size: 16px; color: var(--text-2); margin-top: 7px; line-height: 1.6; }

.rrf-doc {
  background: var(--paper); color: var(--paper-body);
  border-radius: 16px; padding: clamp(32px, 5vw, 60px); margin: 32px 0 64px;
  font-family: var(--serif); font-size: 17.5px; line-height: 1.7;
}
.rrf-doc h2 {
  font-family: var(--display); font-weight: 800; color: var(--paper-ink);
  font-size: clamp(26px, 3.2vw, 33px); letter-spacing: -0.02em; margin-bottom: 16px;
}
.rrf-doc h3 {
  font-family: var(--mono); font-weight: 600; font-size: 12px;
  letter-spacing: 0.14em; text-transform: uppercase; color: var(--paper-mut);
  margin: 38px 0 14px;
}
.rrf-doc p { margin-bottom: 16px; }
.rrf-grade {
  font-family: var(--mono); font-size: 17px; color: var(--paper-ink);
  border-top: 1px solid var(--paper-line); border-bottom: 1px solid var(--paper-line);
  padding: 18px 0; margin: 26px 0;
}
.rrf-finding { border-left: 2px solid var(--brand-paper); padding-left: 20px; margin-bottom: 30px; }
.rrf-finding-q { font-style: italic; color: var(--paper-ink); }
.rrf-finding-w {
  font-family: var(--mono); font-size: 12px; letter-spacing: 0.1em;
  text-transform: uppercase; color: var(--paper-mut); margin-top: 7px;
}
.rrf-finding-n { margin-top: 12px; }

.rrf-ledger { border-top: 1px solid var(--line-soft); padding: 18px 0; }
.rrf-ledger-t { font-size: 17px; }
.rrf-ledger-r { font-size: 15.5px; color: var(--text-3); margin-top: 5px; }
`
